export const DELAY_KEYS = {
  POPUP_TIMEOUT: "popupTimeout"
};
